import React from "react";
import { Button, Flex, Text } from "@chakra-ui/react";

const AdminPagination = ({ page, limit, total, onChange }) => {
  const pages = Math.max(Math.ceil((total || 0) / limit), 1);
  return (
    <Flex mt="5" justify="space-between" align="center" gap="3" flexWrap="wrap">
      <Text color="gray.500" fontSize="sm">
        {total || 0} records · Page {page} of {pages}
      </Text>
      <Flex gap="2">
        <Button
          size="sm"
          variant="outline"
          isDisabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          size="sm"
          variant="outline"
          isDisabled={page >= pages}
          onClick={() => onChange(page + 1)}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
};

export default AdminPagination;
